













































import { Component, Prop, Vue } from 'vue-property-decorator'

import Icon from '@/components/shared/Icon.vue'
import ButtonModule from '@/components/shared/form-controls/ButtonModule.vue'
import { routeNames } from '@/router'

@Component({
  name: 'AuthCard',
  components: {
    Icon,
    ButtonModule
  }
})
export default class AuthCard extends Vue {
  @Prop() title!: string
  @Prop() submitText!: string
  @Prop() submitDisabled?: boolean
  @Prop() submitDisabledTooltip?: string
  @Prop({ default: true }) showBackButton!: string

  login = routeNames.login
}
